import React from 'react';
import Header from '../componentes/Header';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion } from 'framer-motion';
import { Link, useNavigate} from 'react-router';

import productosLambrin from '../data/todosLosProductos/productosLambrin';
import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import styled from 'styled-components';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const PaginaLambrin = () => {
    const navigate = useNavigate();
    return ( 
        <>
        <Helmet>
            <title>Lambrín Decorativo | Hi Blinds</title>
            <meta name="description" content="Paneles decorativos tipo lambrín para techo y muro. Fácil instalación con un acabado moderno." />
            <meta property="og:title" content="Lambrín Decorativo | Hi Blinds" />
            <meta property="og:description" content="Agrega elegancia y estilo moderno a tus espacios con nuestro lambrín ligero y funcional." />
            <meta property="og:url" content="https://hiblindsmx.com/lambrin" />
        </Helmet>
            <Header />
            <AnimacionPagina>
                <SectionProductos>
                    <h1>Lambrin</h1>
                    <BtnVolverAnim Ref='/' />
                    
                <ContainerProductos>
                    {productosLambrin.map((producto, index) =>  {

                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer key={producto.id}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                             onClick={() => {
                              navigate(`/lambrin/${producto.slug}`);
                              }}
                              style={{ cursor: 'pointer' }}
                              >
                                <img 
                                loading='lazy' 
                                src={producto.images[0]}
                                alt={`${producto.nombre}`} 
                                />
                                <h4>{producto.nombre}</h4>
                                <p>Medidas:
                                    <br/> {producto.largo}
                                </p>
                                <Link to={`/lambrin/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
                    <BtnVolverAnim Ref='/' />
                    <WhatsAppShareButton message="¡Revisa nuestros colores de lambrin!" />
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
            
        </>
     );
}

export default PaginaLambrin;